import React from "react";
import { CSSTransition } from "react-transition-group";
import { Agency, AgencyId, TrainingCenterBundleDueDateId } from "../../../messages";
import { TrainingCenterCaregiverBundle } from "../../../system/AppState/AppStateTrainingCenter";
import { assertDefined } from "../../../utils/assertUndefinedable";
import { HashMap } from "../../../utils/HashMap";
import { List } from "../../../utils/List";
import { isDefined } from "../../Generic/IsDefined";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import TrainingCenterAgencyBundles from "./TrainingCenterAgencyBundles";

interface Props {
  isOpen: boolean;
  bundles: List<TrainingCenterCaregiverBundle>;
  agencies: HashMap<AgencyId, Agency>;
  languagePreference: TrainingCenterLanguagePreference;
  transitionDuration: number;
  onClickBundle: (bundleDueDateId: TrainingCenterBundleDueDateId) => void;
}

const TrainingCenterBundlesCategory = (props: Props) => {
  const agencyBundles = groupBundlesByAgency(props.bundles);
  const agencyBundleViews: JSX.Element[] = [];

  for (const [agencyId, bundles] of agencyBundles.entries()) {
    const agency = assertDefined(props.agencies.get(agencyId));

    agencyBundleViews.push(
      <TrainingCenterAgencyBundles
        key={`agency-${agencyId}`}
        agency={agency}
        bundles={bundles}
        languagePreference={props.languagePreference}
        onClickBundle={props.onClickBundle}
      />
    );
  }

  return (
    <CSSTransition
      in={props.isOpen}
      timeout={250}
      unmountOnExit={true}
      classNames="TrainingCenterBundlesCategory"
      style={{ ["--transition-duration" as any]: `${props.transitionDuration}ms` }}
    >
      <div className="TrainingCenterBundlesCategory">{agencyBundleViews}</div>
    </CSSTransition>
  );
};

export default TrainingCenterBundlesCategory;

function groupBundlesByAgency(bundles: List<TrainingCenterCaregiverBundle>) {
  let groups = HashMap.empty<AgencyId, List<TrainingCenterCaregiverBundle>>();

  for (const bundle of bundles) {
    groups = groups.update((value) => {
      return isDefined(value) ? value.append(bundle) : List.fromArray([bundle]);
    }, bundle.agencyId);
  }

  return groups;
}
